import { Component, OnInit, Input } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { QuoteTrackingService } from '../../quote-tracking.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { DeliveryAddress } from '../../../quote-checkout/model/address-models'
import { LaunchDialogService } from '@spartacus/storefront'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'

import { filter, take } from 'rxjs/operators'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../../../shared/services/user-role.service'
import { CommonService } from '../../../../../shared/services/common.service'
import { CurrentQuoteStatus } from '../../../../../models/status/status.model'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-quote-pending-action',
  templateUrl: './quote-pending-action.component.html',
  styleUrls: ['./quote-pending-action.component.scss'],
})
export class QuotePendingActionComponent implements OnInit {
  added = false
  mergeText = 'ADD TO MERGE'
  comment = ''
  lineItems = []
  submitted: boolean
  quoteDetails$: Observable<any>
  public editModal
  quoteDetails: any
  quotes: any[]
  cartId: string
  accessibility = ACCESSIBILITY
  constructor(
    private router: Router,
    private quoteTrackingService: QuoteTrackingService,
    private globalMessageService: GlobalMessageService,
    private launchDialogService: LaunchDialogService,
    private quoteCartService: QuoteCartService,
    private commonService: CommonService,
    private userRoleService: UserRoleService
  ) {
    this.quoteTrackingService.enableMergeQuote$.subscribe((res) => {
      if (res === this.quoteId) {
        this.added = false
      }
    })
  }
  @Input() quoteId
  @Input() dateObject
  paramsData: any
  public status
  shipToAddress: DeliveryAddress
  endUserAddress: DeliveryAddress
  billToAddress: DeliveryAddress
  showRevision: boolean
  CurrentQuoteStatus = CurrentQuoteStatus
  ngOnInit(): void {
    this.cartId = sessionStorage.getItem('cartId-current')
    this.quoteDetails$ = this.quoteTrackingService.getQuoteDetailsFromList(
      this.quoteId,
      this.dateObject.fromDate,
      this.dateObject.toDate
    )
    this.quoteDetails$.subscribe((data) => {
      this.quoteDetails = data
      this.showRevision = true
      this.quoteDetails?.quoteLineDetails.forEach((element) => {
        if (element?.quoteStatusCode !== this.CurrentQuoteStatus.OPEN) {
          this.showRevision = false
          return
        }
      })
    })
    this.quoteTrackingService.getQuotesForMerge.subscribe((quotes) => {
      this.quotes = quotes
      this.added = false
      this.quotes.forEach((element) => {
        if (element.quoteId == this.quoteId) {
          this.added = true
        }
      })
      if (!this.added) {
        this.mergeText = 'ADD TO MERGE'
      }
    })
  }
  selectOperation(event) {
    this.status = event.target.value
    this.submitted = false
  }
  quoteAcceptance() {
    let data = {
      fromDate: this.dateObject.fromDate,
      toDate: this.dateObject.toDate,
      status: this.status,
    }
    this.router.navigate(['quote-acceptance', this.quoteId], {
      queryParams: data,
    })
  }
  quoteMerge() {
    this.added = true
    this.mergeText = 'ADDED TO MERGE'
    this.quotes.push(this.quoteDetails?.quoteDetailsList)
    if (this.quotes.length < 3) {
      this.quoteTrackingService.setQuotesForMerge(this.quotes)
    }
  }
  openModal() {
    this.globalMessageService.add(
      { key: 'quoteTracking.undefinedPart' },
      GlobalMessageType.MSG_TYPE_WARNING,
      8000
    )
    window.scrollTo(0, 0)
    this.quoteCartService.getCart(this.cartId, 'current').subscribe((data) => {
      if (data['entries']?.length > 0) {
        const componentdata = {}

        const quoteEditDialog = this.launchDialogService.openDialog(
          VS_LAUNCH_CALLER.QUOTE_EDIT,
          undefined,
          undefined,
          componentdata
        )
        if (quoteEditDialog) {
          quoteEditDialog.pipe(take(1)).subscribe((value) => {})
          this.launchDialogService.dialogClose
            .pipe(
              filter(
                (dialogResponse: DialogResponse) =>
                  dialogResponse?.type == VS_LAUNCH_CALLER.QUOTE_EDIT
              ),
              take(1)
            )
            .subscribe((value) => {
              if (value?.reason === 'quote-edit') {
                this.quoteRevision()
              } else {
              }
            })
        }
      } else {
        this.quoteRevision()
      }
    })
  }
  quoteRevision() {
    this.submitted = true
    if (this.comment.trim().length > 0) {
      // this.quoteDetails$.subscribe(data => {
      this.quoteDetails?.quoteLineDetails.forEach((element) => {
        if (element?.quoteStatusCode === this.CurrentQuoteStatus.OPEN) {
          var lineItem = {
            brandCode: '',
            brandName: '',
            code: '',
            comment: '',
            csrResponseRequired: true,
            customerRequestedDate: '',
            isUnsolicited: true,
            productType: '',
            quantity: 0,
            quoteCartEntryType: '',
            quoteExtendedPrice: 0,
            quoteNetPrice: 0,
            listPrice: 0,
            reasonForQuote: '',
            rfqPartDescription: '',
            rfqPartNumber: '',
            serialNumber: '',
            tagNumber: '',
            itemNumber: '',
          }
          lineItem = {
            csrResponseRequired: true,
            brandCode: '',
            brandName: '',
            comment: element.additionalComments,
            customerRequestedDate: element.requestedShipDate.replace(/-/g, '/'),
            code: element.partNumber,
            isUnsolicited: true,
            productType: 'Part',
            quantity: Number(element.quantity),
            quoteExtendedPrice: Number(element?.quoteExtendedPrice),
            listPrice: Number(element?.listPrice),
            quoteNetPrice: Number(element?.quoteNetPrice),
            reasonForQuote: '',
            rfqPartDescription: element.partDescription,
            serialNumber: element.serialNumber,
            rfqPartNumber: element.partNumber,
            tagNumber: element.tagNumber,
            quoteCartEntryType: 'EDIT',
            itemNumber: element.itemNumber,
          }
          this.lineItems.push(lineItem)
        }
      })
      var ship = this.quoteDetails?.quoteDetailsList.shipToAddress.split(';')

      this.shipToAddress = {
        partnerNumber: ship[0],
        companyName: ship[1],
        line1: ship[2],
        line2: ship[3],
        town: ship[4],
        region: {
          isocode: `${ship[7]}-${ship[6]}`,
        },
        country: {
          isocode: ship[7],
        },
        postalCode: ship[8],
      }
      var sold = this.quoteDetails?.quoteDetailsList.soldToAddress.split(';')

      this.billToAddress = {
        companyName: sold[0],
        line1: sold[1],
        line2: sold[2],
        town: sold[3],
        region: {
          isocode: `${sold[6]}-${sold[5]}`,
        },
        country: {
          isocode: sold[6],
        },
        postalCode: sold[7],
      }
      var end = this.quoteDetails?.quoteDetailsList.endUserAddresss.split(';')

      this.endUserAddress = {
        partnerNumber: end[0],
        companyName: end[1],
        line1: end[2],
        line2: end[3],
        town: end[4],
        region: {
          isocode: `${end[7]}-${end[6]}`,
        },
        country: {
          isocode: end[7],
        },
        postalCode: end[8],
      }
      var quoteObject = {
        billToAddress: this.billToAddress,
        deliveryAddress: this.shipToAddress,
        endUserAddress: this.endUserAddress,
        quoteCartType: 'EDIT',
        quoteEntries: this.lineItems,
        quoteId: this.quoteId,
        rfqType: this.quoteDetails?.quoteDetailsList?.rfqType,
        customerProjectName:
          this.quoteDetails?.quoteDetailsList?.customerProjectName,
        endUserIndustry: this.quoteDetails?.quoteDetailsList?.endUserIndustry,
        notificationEmail:
          this.quoteDetails?.quoteDetailsList?.notificationEmail,
        comment: this.comment,
      }
      this.quoteTrackingService.editQuote(quoteObject).subscribe(
        (success) => {
          this.setSession(success['cartCode'], function () {})
        },
        (error) => {
          this.submitted = false
        }
      )
      // });
    }
  }
  setSession(cartId, callback) {
    sessionStorage.setItem('cartId-current', cartId)
    sessionStorage.setItem('cartStatus-current', 'added')
    this.router.navigate(['quote/cart'])
    callback()
  }
  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }
}
